export const colors = {
  blue: "#7481C3",
  cyan: "#74C3BF",
  maroom: "#8A637D",
  green: "#8EB26A",
  red: "#C37474",
  darkOrange: "#C39574",
  lightOrange: "#DBB781",
};

